import { render, staticRenderFns } from "./ViewSalesPaymentPage.vue?vue&type=template&id=0f5d6a31"
import script from "./ViewSalesPaymentPage.vue?vue&type=script&lang=js"
export * from "./ViewSalesPaymentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports